const topicItems = [
  { name: '明星恋情', heat: '980万' },
  { name: '综艺爆料', heat: '860万' },
  { name: '影视剧透', heat: '750万' },
  { name: '网红翻车', heat: '620万' },
  { name: '时尚穿搭', heat: '580万' },
  { name: '音乐现场', heat: '490万' },
  { name: '颁奖典礼', heat: '420万' },
  { name: '品牌代言', heat: '380万' },
  { name: '粉丝大战', heat: '350万' },
  { name: '跨界合作', heat: '310万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">话题广场</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">热门话题标签，快速找到你感兴趣的吃瓜方向</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.name}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#ranking');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-secondary-200/60 cursor-pointer hover:bg-primary-50 hover:border-primary-200 transition-all"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">#{item.name}</span>
              <span className="text-xs text-foreground-400 group-hover:text-primary-400 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}